module.exports = __webpack_public_path__ + "static/media/997974.5106454a.png";